const CONTACT_URL = 'https://www.lama.im/contact';

// The site's contact page is Hebrew via ?lang=he; every other UI language
// gets the page's own default, so no query string is added.
export function contactUrlFor(lang) {
  return lang === 'he' ? `${CONTACT_URL}?lang=he` : CONTACT_URL;
}
